module.exports = __webpack_public_path__ + "img/dos-santas-main-bg.66d71d5b.jpg";